module.exports = __webpack_public_path__ + "img/DE05673.488a3744.png";